export interface ILanguage {
    code: string;
    name: string;
    flag: string;
    property: string[];
}

export const languages: ILanguage[] = [
    { code: "en-US", name: "English", flag: "🇺🇸", property: ["AMS", "RTM", "CPH", "RKV"]},
    { code: "nl-NL", name: "Nederlands", flag: "🇳🇱", property: ["AMS", "RTM", "CPH", "RKV"]},
    { code: "da-DK", name: "Dansk", flag: "🇩🇰", property: ["AMS", "RTM", "CPH", "RKV"]},
    { code: "de-DE", name: "Deutsch", flag: "🇩🇪", property: ["AMS", "RTM", "CPH", "RKV"]},
    { code: "fr-FR", name: "Français", flag: "🇫🇷", property: ["AMS", "RTM", "CPH", "RKV"]},
    { code: "is-IS", name: "Íslenska", flag: "🇮🇸", property: ["AMS", "RTM", "CPH", "RKV"]},
    { code: "it-IT", name: "Italiano", flag: "🇮🇹", property: ["AMS", "RTM", "CPH", "RKV"]},
    { code: "es-ES", name: "Español", flag: "🇪🇸", property: ["AMS", "RTM", "CPH", "RKV"]},
    // { code: "sv-SE", name: "Svenska", flag: "🇸🇪", property: ["AMS", "RTM", "CPH", "RKV"]},
];
